import React, { useState } from 'react';
import './css/Cbse.css'; // Dedicated page styles
import { useNavigate } from "react-router-dom";


// Reusing your standalone, modular layout components
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

// Import your custom images here
import cbseHeroBg from '../images/banner-cbse.jpg';
import cbseDetailsImg from '../images/cbse.png';

// Import your custom images here at the top
import cbsetrajectoryImg from '../images/CBSE_Internal_Illustration.png'; // New Background Import
import featureSectionBg2 from '../images/Banner3.png'; // New Background Import

// Slide-Specific Image Imports
import cbsesupportImg from '../images/CBSE_Support.png';
import featureLeftImg2 from '../images/forum-dash1.png';
import featureLeftImg3 from '../images/forum-dash1.png';

import dynamicBg from "../images/Banner6.png"; // New background image asset
import thumb1 from "../images/core1.png";
import thumb2 from "../images/core2.png";
import thumb3 from "../images/core3.png";
import thumb4 from "../images/core4.png";

// Importing images or using dynamic asset paths matching your project structure
import Why1 from "../images/Icon-01.png";
import Why2 from "../images/Icon-02.png";
import Why3 from "../images/Icon-03.png";
import Why4 from "../images/Icon-04.png";
import Why5 from "../images/Icon-04.png";
import Why6 from "../images/Icon-06.png";
import Why7 from "../images/Icon-07.png";
import Why8 from "../images/Icon-08.png";

import Team1 from '../images/founders-icon.png';
import Team2 from '../images/advisors-icon.png';
import Team3 from '../images/patrons-icon.png';
import Team4 from '../images/board-members-icon.png';


import courses1 from '../images/courses-01.jpg';
import courses2 from '../images/courses-02.jpg';
import courses3 from '../images/courses-03.jpg';
import courses4 from '../images/courses-04.jpg';
import courses5 from '../images/courses-05.jpg';
import courses6 from '../images/courses-06.jpg';
import courses7 from '../images/courses-07.jpg';
import courses8 from '../images/courses-08.jpg';
import courses9 from '../images/courses-09.jpg';

// React Icons (Using react-icons/fa or similar icon framework)
import { FaCheckCircle } from "react-icons/fa";

import DownloadApp from './components/DownloadApp';

function Cbse() {
  const navigate = useNavigate();

  // Array holding all box content items
    const allBoxes = [
    {
        id: 1,
        img: courses1,
        title: "Mathematics - FSD",
        subtitle: "Duration: Till the end of academic year. | Test: Yes",
        link: "#courses-1"
    },
    {
        id: 2,
        img: courses2,
        title: "Science - FSD",
        subtitle: "Duration: Till the end of academic year. | Test: Yes",
        link: "#courses-2"
    },
    {
        id: 3,
        img: courses3,
        title: "Social Science - FSD",
        subtitle: "Duration: Till the end of academic year. | Test: Yes",
        link: "#courses-3"
    },
    {
        id: 4,
        img: courses4,
        title: "Mathematics - CMC",
        subtitle: "Duration: Till the end of academic year. | e-Library: Yes",
        link: "#courses-4"
    },
    {
        id: 5,
        img: courses5,
        title: "Science - CMC",
        subtitle: "Duration: Till the end of academic year. | e-Library: Yes",
        link: "#courses-5"
    },
    {
        id: 6,
        img: courses6,
        title: "Social Science - CMC",
        subtitle: "Duration: Till the end of academic year. | e-Library: Yes",
        link: "#courses-6"
    },
    {
        id: 7,
        img: courses7,
        title: "Mathematics - FSD + CMC",
        subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes",
        link: "#courses-7"
    },
    {
        id: 8,
        img: courses8,
        title: "Science - FSD + CMC",
        subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes",
        link: "#courses-8"
    },
    {
        id: 9,
        img: courses9,
        title: "Social Science - FSD + CMC",
        subtitle: "Duration: Till the end of academic year. | Test: Yes, e-Library: Yes",
        link: "#courses-9"
    }
];

    // State tracker toggles whether all elements show or just the initial 4
    const [showAll, setShowAll] = useState(false);

    // Filters items dynamically based on the toggle state
    const visibleBoxes = showAll ? allBoxes : allBoxes.slice(0, 4);

  const mergedFeatures = [
    {
      id: 1,
      title: "Mission & Mathematics Levels",
      accent: "accent-blue",
      image: Why1,
      alt: "Math Levels and Mission",
      description: "Crestest aims to achieve scholastic excellence by nurturing self-aware learners. In alignment with CBSE guidelines introduced in 2020, we support two levels of mathematics—standard and basic—to reduce examination stress while maintaining identical foundational classroom teaching.",
    },
    {
      id: 2,
      title: "Approach & Competency Exams",
      accent: "accent-yellow",
      image: Why2,
      alt: "Approach and Competency Exams",
      description: "We follow a learner-centric approach matching modern CBSE paradigms: strong emphasis on Multiple Choice Questions (MCQs) and competency-based questions (50% weightage), reducing traditional rote learning and short/long-answer pressure.",
    },
    {
      id: 3,
      title: "Quality & Comprehensive Learning",
      accent: "accent-yellow",
      image: Why3,
      alt: "Quality and Project Learning",
      description: "Through concept maps, interactive charts, presentations, and group projects, we focus entirely on comprehensive project-based learning. Our expertly curated audio-visual content builds powerful academic foundations.",
    },
    {
      id: 4,
      title: "Our Commitment & Grading System",
      accent: "accent-blue",
      image: Why4,
      alt: "Grading and Commitment",
      description: "We provide accessible and transparent academic support. Aligning with CBSE's standard 9-point system published in grade terms, we eliminate negative self-judgment, empowering students and parents to track growth effectively.",
    },
    {
      id: 5,
      title: "Structured Study Planning",
      accent: "accent-blue",
      image: Why5,
      alt: "Structured Study Planning",
      description: "Certification of general education without study diversification requires meticulous planning. We craft solid, step-by-step study itineraries that smoothly accentuate candidate preparation for board success.",
    },
    {
      id: 6,
      title: "Holistic Growth & SUPW",
      accent: "accent-yellow",
      image: Why6,
      alt: "Holistic Growth and SUPW",
      description: "All candidates sit for five core subjects alongside SUPW. We provide expanded digital opportunities to seek practical knowledge, skill-building, and holistic development far beyond standard textbook boundaries.",
    },
    {
      id: 7,
      title: "Verified Regular Curriculum",
      accent: "accent-yellow",
      image: Why7,
      alt: "Regular Candidate Eligibility",
      description: "Tailored strictly for regular enrolled students attending structured terms, our platform mirrors legitimate school environments to ensure hassle-free, authorized preparation without private candidate ambiguities.",
    },
    {
      id: 8,
      title: "Vocational & Future Pathways",
      accent: "accent-blue",
      image: Why8,
      alt: "Vocational Streams",
      description: "We incorporate vocational subjects available across every stream. These stand in sharp contrast to purely theoretical courses, opening up a plethora of professional career pathways for future professions.",
    },
  ];

  return (
    <div className="cbse-page-wrapper">

      {/* 1. Header Hero Section with integrated clean Navbar */}
      <section
        className="cbse-hero-section"
        style={{ backgroundImage: `url(${cbseHeroBg})` }}
      >
        <Navbar />
      </section>

      {/* 2. Core Narrative & Brand Pillars Section */}
      <section className="cbse-details-section">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* Left Column: Contextual Narrative */}
            <div className="col-lg-6">
              <p className="info-small-text">KNOW YOUR BOARD</p>

              <h2 className="cbse-section-heading">
                Empowering Every Student to Learn & Succeed
              </h2>

              <div className="zigzag-divider mb-4"></div>

              <p className="cbse-body-text">
                The CBSE is a national board of education run by the Government of India, and recognized internationally. All CBSE-affiliated schools follow the NCERT (National Council of Educational Research and Training) curriculum.
              </p>

              <p className="cbse-body-text">
                The first of the two major examinations conducted by the board, the CBSE-class X board exams act as a key factor for getting admission in higher secondary schools of your choice, and the results form an important part of the student’s resume.
              </p>

              <p className="cbse-body-text highlighted-paragraph">
                The CBSE Board aims to provide inclusive and holistic education to its students, and is known for its comprehensive syllabus and methodical examination pattern. Crestest builds on this foundation with board exam preparation, competitive test series, the free "Try Before You Buy" portal, Scholars' Forum, and the nationwide Kirnavali challenge.
              </p>

              {/* Metric Pillars Grid */}
              <div className="row g-3 mt-4">
                <div className="col-sm-4">
                  <div className="metric-box box-blue">
                    <h3 style={{ color: "#fff" }}>AI</h3>
                    <p style={{ color: "#fff", fontSize: "11px" }}>
                      Personalized Learning
                    </p>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="metric-box box-yellow">
                    <h3 style={{ color: "#fff" }}>24/7</h3>
                    <p style={{ color: "#fff" }}>
                      Smart Practice
                    </p>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="metric-box box-teal">
                    <h3 style={{ color: "#fff" }}>FREE</h3>
                    <p style={{ color: "#fff", fontSize: "11px" }}>
                      Try Before You Buy
                    </p>
                  </div>
                </div>
              </div>


            </div>

            {/* Right Column: Clean, Unboxed Raw Image Layout */}
            <div className="col-lg-6 text-center">
              <img
                src={cbseDetailsImg}
                alt="Enterprise Architecture"
                className="img-fluid"
                style={{
                  border: "none",
                  boxShadow: "none",
                  outline: "none",
                  borderRadius: 0,
                  background: "transparent",
                  display: "block",
                  margin: "0 auto"
                }}
              />
            </div>

          </div>
        </div>
      </section>


      {/* 4. NEW: Expandable Grid Grid Section */}
            <section
                className="dynamic-grid-section"
                style={{ backgroundImage: `url(${dynamicBg})` }}
            >
                <div className="container">

                    {/* Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8 d-flex flex-column align-items-center">
                            <p className="cards-small-text">CBSE Courses</p>

                            <h2 className="cards-main-heading">
                                The CBSE Courses We Offer
                            </h2>

                            <div className="zigzag-border"></div>
                        </div>
                    </div>

                    {/* Responsive 4-Column Grid Array */}
                    <div className="row g-4 justify-content-center transition-grid">
                        {visibleBoxes.map((box) => (
                            <div className="col-sm-6 col-md-4 col-lg-3" key={box.id}>
                                <div className="grid-item-card">
                                    <div className="grid-thumb-wrap">
                                        <img src={box.img} alt={box.title} className="grid-card-img" />
                                    </div>
                                    <div className="grid-card-body text-center">
                                        <h4 className="grid-title">{box.title}</h4>
                                        <p className="grid-subtitle">{box.subtitle}</p>
                                        {/* <a href={box.link} className="btn grid-action-btn">
                                            VIEW DETAILS
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Expandable Pagination Control Button */}
                    {allBoxes.length > 4 && (
                        <div className="row mt-5">
                            <div className="col-12 text-center">
                                <button
                                    className="btn view-more-toggle-btn"
                                    onClick={() => setShowAll(!showAll)}
                                >
                                    {showAll ? "SHOW LESS" : "VIEW MORE"}
                                </button>
                            </div>
                        </div>
                    )}

                </div>
            </section>




      {/* 4. Glassmorphic Grid Services / Capabilities Section */}
      <section className="cbse-grid-bg-section" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
        <div className="container">

          {/* Centralized Section Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <span className="grid-section-mini-tag">Key features</span>
              <h2 className="grid-section-heading">CBSE works with the vision of being “committed to equity and excellence in education.”</h2>
              <div className="zigzag-border mx-auto mt-3"></div>
            </div>
          </div>

          {/* Dynamic 2 Cards Per Row Grid */}
          <div className="row g-4 justify-content-center">
            {mergedFeatures.map((feature) => (
              <div className="col-lg-6" key={feature.id}>
                <div className="glass-grid-box h-100">
                  <div className="grid-box-inner">
                    <div className={`grid-square-icon-wrapper ${feature.accent}`}>
                      <img
                        src={feature.image}
                        alt={feature.alt}
                        className="grid-panel-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>

                    <div className="grid-box-text-block">
                      <h4>{feature.title}</h4>
                      <p className="mb-0">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

     
      <section className="cbse-details-section py-5" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
        <div className="container">
          {/* Professional Border-Radiused & Box-Shadowed Container Box */}
          <div
            className="p-4 p-lg-5 bg-white rounded-4"
            style={{
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
              border: "1px solid rgba(0, 0, 0, 0.04)"
            }}
          >
            <div className="row align-items-center g-5">

              {/* Left Column: Contextual Narrative & Academic Trajectory Setting */}
              <div className="col-lg-6">
                <span className="info-small-text text-uppercase fw-bold text-primary tracking-wide">
                  KNOW YOUR BOARD
                </span>

                <h2 className="cbse-section-heading fw-bold mt-2 mb-3" style={{ fontSize: "2rem", color: "#2d3748" }}>
                  Academic Trajectory Setting & Evaluation
                </h2>

                <div className="zigzag-divider mb-4" style={{ width: "50px", height: "4px", background: "#3182ce", borderRadius: "2px" }}></div>

                <p className="cbse-body-text text-muted mb-4" style={{ lineHeight: "1.7" }}>
                  An ongoing, comprehensive process of evaluating and setting individual academic trajectories based on those evaluations. These are conducted internally, unknown to the students, throughout the academic session.
                </p>

                {/* Structured Pointers List with React Icons */}
                <ul className="list-unstyled mb-4">
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>Question Curation:</strong> A set of questions is provided by each of 3 or 4 SMEs selected by the Council, of which one is selected and approved by a team of moderators.</span>
                  </li>
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>Mandatory Requirements:</strong> Unit tests, explanatory activities, practical exams and project work are mandatory.</span>
                  </li>
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>Assessment Weightage:</strong> There will be four types of questions—periodic tests, multiple assessments, portfolio, and subject enrichment activities—each carrying 5 marks.</span>
                  </li>
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>Attendance Criteria:</strong> A minimum attendance of 75% is strictly required.</span>
                  </li>
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>Promotion Policy:</strong> Promotion on a trial basis is not accepted.</span>
                  </li>
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>SUPW Evaluation:</strong> SUPW is comprehensively assessed by the school.</span>
                  </li>
                </ul>

                
              </div>

              {/* Right Column: Clean, Unboxed Raw Image Layout */}
              <div className="col-lg-6 text-center">
                <img
                  src={cbsetrajectoryImg}
                  alt="Academic Trajectory Architecture"
                  className="img-fluid"
                  style={{
                    border: "none",
                    boxShadow: "none",
                    outline: "none",
                    borderRadius: 0,
                    background: "transparent",
                    display: "block",
                    margin: "0 auto",
                    maxHeight: "450px",
                    objectFit: "contain"
                  }}
                />
              </div>

            </div>
          </div>
        </div>
      </section>

       {/* Download App Section */}
      <DownloadApp />


      {/* Support & Pedagogy Section */}
      <section className="cbse-details-section py-5" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
        <div className="container">
          <div
            className="p-4 p-lg-5 bg-white rounded-4"
            style={{
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
              border: "1px solid rgba(0, 0, 0, 0.04)"
            }}
          >
            <div className="row align-items-center g-5">

               {/* Right Column: Illustration Image */}
              <div className="col-lg-6 text-center">
                <img
                  src={cbsesupportImg}
                  alt="Support and Pedagogy Illustration"
                  className="img-fluid"
                  style={{
                    border: "none",
                    boxShadow: "none",
                    outline: "none",
                    borderRadius: 0,
                    background: "transparent",
                    display: "block",
                    margin: "0 auto",
                    maxHeight: "450px",
                    objectFit: "contain"
                  }}
                />
              </div>
              
              {/* Left Column: Support & Pedagogy Narrative & Pointers */}
              <div className="col-lg-6">
                <span className="info-small-text text-uppercase fw-bold text-primary tracking-wide">
                  EXPERT ASSISTANCE
                </span>

                <h2 className="cbse-section-heading fw-bold mt-2 mb-3" style={{ fontSize: "2rem", color: "#2d3748" }}>
                  Support & Comprehensive Pedagogy
                </h2>

                <div className="zigzag-divider mb-4" style={{ width: "50px", height: "4px", background: "#3182ce", borderRadius: "2px" }}></div>

                <p className="cbse-body-text text-muted mb-4" style={{ lineHeight: "1.7" }}>
                  Crestest offers premium services and in-depth support for students enrolled in CBSE. Our pedagogy of practice includes FSD, CMC, NBF and PSC.
                </p>

                <ul className="list-unstyled mb-4">
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>FSD (Foundation Status & Diagnostic):</strong> Will help students understand their current academic level through online tests and subsequent assessment.</span>
                  </li>
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>CMC (Comprehensive Media Centre):</strong> With its vast collection of digital content, will resource them with the necessary knowledge and skills.</span>
                  </li>
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>NBF (Next-Gen Board Facility):</strong> The unique facility, with the notes, whiteboard and faculty in a single window, will facilitate powerful learning opportunities during online classes.</span>
                  </li>
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>PSC (Performance & Support Coaching):</strong> Will help them track their growth and plan the next step.</span>
                  </li>
                  <li className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-primary mt-1 me-3 flex-shrink-0" size={18} />
                    <span><strong>Counselling Support:</strong> Can bring self-awareness and the ability to move forward with a growth mindset.</span>
                  </li>
                </ul>
              </div>

             

            </div>
          </div>
        </div>
      </section>

      {/* 3. Reusable Global Bottom Components */}
      <Newsletter />
      <Footer />

    </div>
  );
}

export default Cbse;